// import { Component, forwardRef, Input } from '@angular/core';
// import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// @Component({
//   selector: 'app-app-textarea',
//   templateUrl: './app-textarea.component.html',
//   styleUrls: ['./app-textarea.component.css']
// })
// export class AppTextareaComponent {

// }
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-app-textarea',
  templateUrl: './app-textarea.component.html',
  styleUrls: ['./app-textarea.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppTextareaComponent),
      multi: true
    }
  ]
})
export class AppTextareaComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  text: string = '';

  // ControlValueAccessor interface methods
  onChange: any = () => {};
  onTouch: any = () => {};

  set value(val: string) {
    this.text = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: any): void {
    if (value) {
      this.text = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}

